import { useTheme } from '@mui/material';
import { ImageAsset as TImageAsset, Maybe } from '@/types/generated';
import { BlogImage } from './BlogDetailsPage';
import FocalPointImage from '@shared-components/components/FocalPointImage';
import ImageAsset from '@shared-components/components/ImageAsset';
import { IImage } from '@shared-components/components/ImageAsset/ImageAsset';
import { ImagePriorityContext } from '@utils/images/imageOptimization';
export default function BlogDetailsImageAssetContainer({
  imageAsset,
  blogImage,
  usePreloader,
  isSmallScreen
}: {
  blogImage?: Maybe<BlogImage>;
  imageAsset?: Maybe<TImageAsset>;
  usePreloader?: boolean;
  isSmallScreen: boolean;
}) {
  const theme = useTheme();
  const desktopMobileID = isSmallScreen ? 'mobile' : 'desktop';
  return usePreloader && <ImagePriorityContext.Provider value={1}>
				{imageAsset ? <ImageAsset loading="eager" desktopImage={imageAsset?.desktopImage as IImage} mobileImage={imageAsset?.mobileImage as IImage} dataTestId="blog_detail_page_img_asset_focal_point_image_desktop" /> : <FocalPointImage loading="eager" brandFolderImage={blogImage?.image} focalPoint={blogImage?.focalPoint} sizes={`${theme.breakpoints.up('md').replaceAll('@media', '')} 50vw, 100vw`} dataTestId="blog_detail_page_focal_point_image_desktop" />}
			</ImagePriorityContext.Provider> || <>
				{imageAsset ? <ImageAsset loading="eager" desktopImage={imageAsset?.desktopImage as IImage} mobileImage={imageAsset?.mobileImage as IImage} dataTestId={`blog_detail_page_img_asset_focal_point_image_${desktopMobileID}`} /> : <FocalPointImage loading="eager" brandFolderImage={blogImage?.image} focalPoint={blogImage?.focalPoint} sizes={`${theme.breakpoints.up('md').replaceAll('@media', '')} 50vw, 100vw`} dataTestId={`blog_detail_page_focal_point_image_${desktopMobileID}`} />}
			</>;
}